import React from 'react';
import { Wifi, WifiOff, Fingerprint, RefreshCw } from 'lucide-react';
interface StatusBarProps {
  isOnline: boolean;
  isScannerConnected: boolean;
  lastSyncTime: string;
}
export function StatusBar({
  isOnline,
  isScannerConnected,
  lastSyncTime
}: StatusBarProps) {
  return <div className="bg-slate-800 border-b border-slate-700 px-4 py-2 flex items-center justify-between text-xs text-slate-400 sticky top-0 z-50" data-id="element-67">
      <div className="flex items-center space-x-4" data-id="element-68">
        <div className={`flex items-center space-x-1.5 ${isOnline ? 'text-green-400' : 'text-slate-500'}`} data-id="element-69">
          {isOnline ? <Wifi size={14} data-id="element-70" /> : <WifiOff size={14} data-id="element-71" />}
          <span className="font-medium" data-id="element-72">{isOnline ? 'Online' : 'Offline'}</span>
        </div>

        <div className={`flex items-center space-x-1.5 ${isScannerConnected ? 'text-blue-400' : 'text-red-400'}`} data-id="element-73">
          <Fingerprint size={14} data-id="element-74" />
          <span className="font-medium" data-id="element-75">
            {isScannerConnected ? 'Scanner Ready' : 'Scanner Disconnected'}
          </span>
        </div>
      </div>

      <div className="flex items-center space-x-1.5" data-id="element-76">
        <RefreshCw size={12} data-id="element-77" />
        <span data-id="element-78">Sync: {lastSyncTime}</span>
      </div>
    </div>;
}